// AboutScreen.js
import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Image,
  Linking,
  Dimensions,
} from 'react-native';
import Icon from 'react-native-vector-icons/MaterialIcons';

const {width} = Dimensions.get('window');

const AboutScreen = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'মোঃ সিদ্দিক উল্যা',
      designation: 'প্রতিষ্ঠাতা ও ব্যবস্থাপনা পরিচালক',
      icon: 'person',
    },
    {
      id: 2,
      name: 'অ্যাডভোকেট মোঃ সাদেক জিলানী জিশান',
      designation: 'প্রধান আইনি উপদেষ্টা',
      icon: 'gavel',
    },
    {
      id: 3,
      name: 'মোঃ শফিকুল হায়দার',
      designation: 'প্রযুক্তি প্রধান',
      icon: 'computer',
    },
    // {
    //   id: 4,
    //   name: 'মিসেস নাসরিন আক্তার',
    //   designation: 'গ্রাহক সেবা ব্যবস্থাপক',
    //   icon: 'support-agent',
    // },
  ];

  const features = [
    {id: 1, title: 'অনলাইন মামলা ব্যবস্থাপনা', icon: 'folder-open'},
    {id: 2, title: 'আইনি ডকুমেন্ট প্রস্তুত', icon: 'description'},
    {id: 3, title: 'অটো এসএমএস নোটিফিকেশন', icon: 'sms'},
    {id: 4, title: '২৪/৭ গ্রাহক সহায়তা', icon: 'headset-mic'},
    {id: 5, title: 'সুরক্ষিত ডেটা সংরক্ষণ', icon: 'security'},
    {id: 6, title: 'আইন গবেষণা ও বিশ্লেষণ', icon: 'analytics'},
  ];

  const handleCall = () => {
    Linking.openURL('tel:+8801772-72 78 78');
  };

  const handleEmail = () => {
    Linking.openURL('mailto:info@bdjudgecourt.com');
  };

  const handleWebsite = () => {
    Linking.openURL('https://bdjudgecourt.com');
  };

  return (
    <ScrollView
      style={styles.container}
      showsVerticalScrollIndicator={false}
      contentContainerStyle={styles.scrollContent}
    >
      {/* Header */}
      <View style={styles.header}>
        <Text style={styles.headerTitle}>আমাদের সম্পর্কে</Text>
        <Text style={styles.headerSubtitle}>
          ঢাকা কোর্ট ডিজিটাল প্ল্যাটফর্ম
        </Text>
      </View>
      <View style={styles.container_body}>
        {/* Powered By */}
        {/* <View style={styles.poweredByContainer}>
        <Text style={styles.poweredByText}>
          Powered By: Siddique Enterprise
        </Text>
      </View> */}

        {/* About Card */}
        <View style={styles.aboutCard}>
          <View style={styles.logoContainer}>
            <Icon name="gavel" size={50} color="#307ecc" />
          </View>
          <Text style={styles.aboutTitle}>বিডি জাজ কোর্ট</Text>
          <Text style={styles.aboutSubtitle}>
            একটি ডিজিটাল আইনি সেবা প্ল্যাটফর্ম
          </Text>
          <Text style={styles.aboutDescription}>
            বিডি জাজ কোর্ট বাংলাদেশের প্রথম সম্পূর্ণ ডিজিটাল আইনি সেবা
            প্ল্যাটফর্ম। আমাদের লক্ষ্য হল সাধারণ মানুষ থেকে শুরু করে আইনজীবী ও
            বিচারকর্মীদের জন্য সহজ, দ্রুত এবং নির্ভরযোগ্য আইনি সেবা প্রদান করা।
          </Text>
          <View style={styles.statsContainer}>
            <View style={styles.statItem}>
              <Text style={styles.statNumber}>৫০০০+</Text>
              <Text style={styles.statLabel}>সক্রিয় ব্যবহারকারী</Text>
            </View>
            <View style={styles.statItem}>
              <Text style={styles.statNumber}>১৩০০০০+</Text>
              <Text style={styles.statLabel}>মামলা ব্যবস্থাপনা</Text>
            </View>
            <View style={styles.statItem}>
              <Text style={styles.statNumber}>৯৯%</Text>
              <Text style={styles.statLabel}>সন্তুষ্টি হার</Text>
            </View>
          </View>
        </View>

        {/* Mission & Vision */}
        <View style={styles.missionContainer}>
          <View style={styles.missionCard}>
            <View style={styles.missionIconContainer}>
              <Icon name="target" size={28} color="#fff" />
            </View>
            <Text style={styles.missionTitle}>আমাদের লক্ষ্য</Text>
            <Text style={styles.missionText}>
              বাংলাদেশের জনগণের কাছে সহজ ও সাশ্রয়ী আইনি সেবা পৌঁছে দেওয়া এবং
              আইনি প্রক্রিয়াকে ডিজিটালাইজ করার মাধ্যমে স্বচ্ছতা ও জবাবদিহিতা
              নিশ্চিত করা।
            </Text>
          </View>

          <View style={styles.missionCard}>
            <View
              style={[
                styles.missionIconContainer,
                {backgroundColor: '#4CAF50'},
              ]}
            >
              <Icon name="visibility" size={28} color="#fff" />
            </View>
            <Text style={styles.missionTitle}>আমাদের স্বপ্ন</Text>
            <Text style={styles.missionText}>
              একটি ডিজিটাল বাংলাদেশ গঠনে আইনি খাতের অগ্রণী ভূমিকা পালন করা
              যেখানে প্রতিটি নাগরিক আইনি সেবা পাবে তার প্রান্তিক পর্যায়ে।
            </Text>
          </View>
        </View>

        {/* Features */}
        <View style={styles.featuresSection}>
          <Text style={styles.sectionTitle}>আমাদের বৈশিষ্ট্য</Text>
          <View style={styles.featuresGrid}>
            {features.map(feature => (
              <View key={feature.id} style={styles.featureCard}>
                <View style={styles.featureIconContainer}>
                  <Icon name={feature.icon} size={24} color="#307ecc" />
                </View>
                <Text style={styles.featureTitle}>{feature.title}</Text>
              </View>
            ))}
          </View>
        </View>

        {/* Team */}
        <View style={styles.teamSection}>
          <Text style={styles.sectionTitle}>আমাদের টিম</Text>
          <ScrollView
            horizontal
            showsHorizontalScrollIndicator={false}
            contentContainerStyle={styles.teamScrollContent}
          >
            {teamMembers.map(member => (
              <View key={member.id} style={styles.teamCard}>
                <View style={styles.teamAvatar}>
                  <Icon name={member.icon} size={32} color="#fff" />
                </View>
                <Text style={styles.teamName}>{member.name}</Text>
                <Text style={styles.teamDesignation}>{member.designation}</Text>
              </View>
            ))}
          </ScrollView>
        </View>

        {/* Contact Quick Actions */}
        <View style={styles.contactSection}>
          <Text style={styles.sectionTitle}>যোগাযোগ করুন</Text>
          <View style={styles.contactGrid}>
            <TouchableOpacity
              style={styles.contactItem}
              onPress={handleCall}
              activeOpacity={0.7}
            >
              <View
                style={[
                  styles.contactIconContainer,
                  {backgroundColor: '#4CAF50'},
                ]}
              >
                <Icon name="phone" size={24} color="#fff" />
              </View>
              <Text style={styles.contactLabel}>ফোন</Text>
              <Text style={styles.contactValue}>+৮৮০ ১৭৭২-৭২ ৭৮ ৭৮</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.contactItem}
              onPress={handleEmail}
              activeOpacity={0.7}
            >
              <View
                style={[
                  styles.contactIconContainer,
                  {backgroundColor: '#FF6B6B'},
                ]}
              >
                <Icon name="email" size={24} color="#fff" />
              </View>
              <Text style={styles.contactLabel}>ইমেইল</Text>
              <Text style={styles.contactValue}>info@bdjudgecourt.com</Text>
            </TouchableOpacity>

            <TouchableOpacity
              style={styles.contactItem}
              onPress={handleWebsite}
              activeOpacity={0.7}
            >
              <View
                style={[
                  styles.contactIconContainer,
                  {backgroundColor: '#307ecc'},
                ]}
              >
                <Icon name="language" size={24} color="#fff" />
              </View>
              <Text style={styles.contactLabel}>ওয়েবসাইট</Text>
              <Text style={styles.contactValue}>bdjudgecourt.com</Text>
            </TouchableOpacity>
          </View>
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            © ২০২৬ বিডি জাজ কোর্ট - সর্বস্বত্ব সংরক্ষিত
          </Text>
          <Text style={styles.footerSubText}>
            ডিজাইন ও ডেভেলপমেন্ট: সিদ্দিক এন্টারপ্রাইজ
          </Text>
        </View>
      </View>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  container_body: {
    paddingHorizontal: 40,
  },
  scrollContent: {
    paddingBottom: 20,
  },
  header: {
    backgroundColor: '#307ecc',
    padding: 10,
    paddingTop: 10,
    paddingLeft: 40,
    // paddingBottom: 16,
  },
  headerTitle: {
    fontSize: 22,
    fontWeight: 'bold',
    color: '#fff',
  },
  headerSubtitle: {
    fontSize: 13,
    color: '#fff',
    opacity: 0.9,
    marginTop: 2,
  },
  poweredByContainer: {
    backgroundColor: '#fff',
    paddingVertical: 8,
    paddingHorizontal: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  poweredByText: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  aboutCard: {
    backgroundColor: '#fff',
    margin: 12,
    padding: 20,
    borderRadius: 12,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 4,
  },
  logoContainer: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: '#e8f0fe',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
  },
  aboutTitle: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#333',
  },
  aboutSubtitle: {
    fontSize: 14,
    color: '#307ecc',
    marginTop: 2,
  },
  aboutDescription: {
    fontSize: 14,
    color: '#555',
    textAlign: 'center',
    lineHeight: 22,
    marginTop: 10,
    paddingHorizontal: 8,
  },
  statsContainer: {
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    marginTop: 16,
    paddingTop: 16,
    borderTopWidth: 1,
    borderTopColor: '#f0f0f0',
  },
  statItem: {
    alignItems: 'center',
  },
  statNumber: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#307ecc',
  },
  statLabel: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  missionContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingHorizontal: 6,
  },
  missionCard: {
    backgroundColor: '#fff',
    flex: 1,
    minWidth: (width - 136) / 2,
    margin: 6,
    padding: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  missionIconContainer: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: '#307ecc',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  missionTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 6,
  },
  missionText: {
    fontSize: 13,
    color: '#555',
    lineHeight: 20,
  },
  featuresSection: {
    backgroundColor: '#fff',
    margin: 12,
    padding: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#333',
    marginBottom: 14,
  },
  featuresGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  featureCard: {
    width: (width - 60) / 3,
    alignItems: 'center',
    paddingVertical: 10,
  },
  featureIconContainer: {
    width: 44,
    height: 44,
    borderRadius: 22,
    backgroundColor: '#e8f0fe',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 6,
  },
  featureTitle: {
    fontSize: 11,
    color: '#555',
    textAlign: 'center',
    fontWeight: '500',
  },
  teamSection: {
    backgroundColor: '#fff',
    margin: 12,
    padding: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  teamScrollContent: {
    paddingRight: 16,
  },
  teamCard: {
    alignItems: 'center',
    marginRight: 16,
    minWidth: 90,
  },
  teamAvatar: {
    width: 60,
    height: 60,
    borderRadius: 30,
    backgroundColor: '#307ecc',
    justifyContent: 'center',
    alignItems: 'center',
  },
  teamName: {
    fontSize: 13,
    fontWeight: '600',
    color: '#333',
    textAlign: 'center',
    marginTop: 6,
  },
  teamDesignation: {
    fontSize: 11,
    color: '#666',
    textAlign: 'center',
  },
  contactSection: {
    backgroundColor: '#fff',
    margin: 12,
    padding: 16,
    borderRadius: 12,
    shadowColor: '#000',
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 4,
    elevation: 2,
  },
  contactGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  contactItem: {
    alignItems: 'center',
    paddingVertical: 8,
    minWidth: (width - 56) / 3,
  },
  contactIconContainer: {
    width: 44,
    height: 44,
    borderRadius: 22,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 4,
  },
  contactLabel: {
    fontSize: 12,
    color: '#666',
  },
  contactValue: {
    fontSize: 11,
    color: '#333',
    fontWeight: '500',
    textAlign: 'center',
  },
  footer: {
    padding: 16,
    alignItems: 'center',
  },
  footerText: {
    fontSize: 12,
    color: '#666',
    textAlign: 'center',
  },
  footerSubText: {
    fontSize: 11,
    color: '#999',
    textAlign: 'center',
    marginTop: 2,
  },
});

export default AboutScreen;
